export default __webpack_public_path__ + "static/media/ezkoop.4ad5a08c.png";